//@flow
import * as React from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';
import ContainerRowSpace from '../../components/common/ContainerRowSpace'
import ContainerRowTitle from '../../components/common/ContainerRowTitle'
import ContainerRowError from '../../components/common/ContainerRowError'
import InstructionAndDocLink from './InstructionAndDocLink'
import InvoiceHeaderContainer from './InvoiceHeaderContainer'

const InvoiceDataExtractionForm = props => {
    const { hermes,location } = props;
    const query = queryString.parse(location.search);
    
    if (!query.jwt || !query.docUrl || !query.taskAcceptedInfoId ) {
        return (
            <div className="container">
               <ContainerRowSpace />
               <ContainerRowTitle title={'Invoice Data Extraction'} />
               <ContainerRowError errorMsg={'Missing Parameters!'} /> 
            </div>
        )
    }
    
    return (
        <div className="container">
            <ContainerRowSpace />
            <ContainerRowTitle title={'Invoice Data Extraction'} />
            <InstructionAndDocLink docLink={query.docUrl} />
            <InvoiceHeaderContainer query={query}/>
        </div>
    )
}

const mapStateToProps = (state, ownProps) => {
    return {
        hermes: state.hermes
    }
}

export default connect(mapStateToProps)(InvoiceDataExtractionForm);


// WEBPACK FOOTER //
// ./src/views/ProjectHermes/InvoiceDataExtractionForm.js